import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ServicePage from "@/components/service/ServicePage";
import Seo, { breadcrumbLd, serviceLd } from "@/components/seo/Seo";
import { UK_SERVICE_CONFIGS, UK_SERVICE_KEYWORDS } from "@/data/ukConfigs";
import { SERVICE_FAQS } from "@/data/faqs";

/**
 * UKServicePage — dedicated UK service landing pages mounted at /uk/:slug.
 * Uses the same premium <ServicePage /> template with UK-specific configs.
 */
export default function UKServicePage() {
  const { slug } = useParams();
  const config = UK_SERVICE_CONFIGS[slug];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [slug]);

  if (!config) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-40 text-center">
        <Seo title="UK service not found" noindex />
        <h1 className="font-heading font-bold text-3xl">Page not found</h1>
        <Link to="/uk" className="mt-4 inline-block text-primary">Back to UK page</Link>
      </div>
    );
  }

  // Inject FAQs from parent slug so we don't duplicate content.
  const faqs = SERVICE_FAQS[config.parent] || SERVICE_FAQS[slug] || [];

  return (
    <>
      <Seo
        title={config.name}
        description={config.hero.subtitle}
        keywords={UK_SERVICE_KEYWORDS[slug]}
        image={config.hero_image}
        canonical={`https://www.cloudlabweb.com/uk/${slug}`}
        type="website"
        jsonLd={[
          serviceLd({
            name: config.name,
            description: config.hero.subtitle,
            slug: `../uk/${slug}`,
          }),
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "United Kingdom", path: "/uk" },
            { name: config.name, path: `/uk/${slug}` },
          ]),
        ]}
      />
      <ServicePage config={{ ...config, __faqs: faqs }} marketSlug="uk" />
    </>
  );
}
